export const ALLOWED_ACTION = {
  READ_ONLY: 1,
  READ_AND_WRITE: 2,
};
